import { render, staticRenderFns } from "./StampList.vue?vue&type=template&id=05d2a8aa&"
import script from "./StampList.vue?vue&type=script&lang=js&"
export * from "./StampList.vue?vue&type=script&lang=js&"
import style0 from "./StampList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports